import * as THREE from 'three';

const vertexShader = `
  varying vec2 vUv;
  void main() {
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0);
  }
`;

const fragmentShader = `
  uniform sampler2D map;
  varying vec2 vUv;
  uniform float dimension;
  void main() {
    vec2 uv_coord = vUv;
    uv_coord.x *= dimension;
    gl_FragColor = texture2D(map, uv_coord);
  }
`;

export default class WallShaderMaterial extends THREE.ShaderMaterial {
  constructor(texture, dimension = 2) {
    super({
      uniforms: {
        map: { value: texture },
        dimension: { value: dimension },
      },
      vertexShader,
      fragmentShader,
    });
  }
}
